
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/premsa/audiencies",
      function () {
        return require("private-next-pages/corporatiu/premsa/audiencies/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/premsa/audiencies"])
      });
    }
  